import { InformationMessage, IBaseComponentProps, Icon, IconSize, IconName, FlexBox } from '@agilepoint/wat-react-ux';
import styled from 'styled-components';

interface ICommonInformationMessageProps extends IBaseComponentProps {
    message: string;
    iconName: IconName;
    iconSize: IconSize;
}

const DisplayMessageWrapper = styled(FlexBox).attrs({
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
})`
    width: 100%;
    height: 100%;
`;

const DisplayMessage = styled(InformationMessage)`
    width: auto;
    font-size: 18px;
`;

export function CommonInformationMessage(props: ICommonInformationMessageProps) {
    const { message, iconName, iconSize, className } = props;
    return (
        <DisplayMessageWrapper className={className}>
            <Icon iconName={iconName} iconSize={iconSize} />
            <DisplayMessage message={message} />
        </DisplayMessageWrapper>
    );
}
